import { Component } from '@angular/core';

@Component({
  selector: 'ap-page-content',
  templateUrl: './page-content.component.html',
  styleUrls: ['./page-content.component.css']
})
export class PageContentComponent {

  constructor() {}

}
